/** Two letters for an avatar: from a name when there is one, else from the address. */
export function initialsOf(name: string | null | undefined, email: string): string {
  const source = name?.trim() || email.split('@')[0].replace(/[._-]+/g, ' ');
  const parts = source.split(/\s+/).filter(Boolean);
  const letters = parts.length >= 2 ? parts[0][0] + parts[parts.length - 1][0] : source.slice(0, 2);
  return letters.toUpperCase();
}
